module.exports = __webpack_public_path__ + "static/media/avatar_03.79f13c82.png";